import { Base } from '@studiometa/js-toolkit';

/**
 * HomeHeader class.
 */
export default class HomeHeader extends Base {
  static config = {
    name: 'HomeHeader',
  };

  /**
   * Mounted.
   * @returns {void}
   */
  mounted() {
    this.toggleBackground(window.scrollY);
  }

  /**
   * Scrolled.
   * @param {{y: number}} param0 Y scroll.
   * @returns {void}
   */
  scrolled({ y }) {
    this.toggleBackground(y);
  }

  /**
   * Toggle the header background.
   * @param {number} scrollY Y scroll value.
   * @returns {void}
   */
  toggleBackground(scrollY) {
    if (scrollY > 16) {
      this.$el.classList.remove('header--no-background');
    } else {
      this.$el.classList.add('header--no-background');
    }
  }
}
